import { DevTools, Tolgee, BackendFetch, LanguageDetector } from "@tolgee/web";
import { FormatIcu } from "@tolgee/format-icu";
import { env } from "@copilot/config/env";
import type { Language } from "@copilot/api";

const apiKey = env.NEXT_PUBLIC_TOLGEE_API_KEY;
const apiUrl = env.NEXT_PUBLIC_TOLGEE_API_URL;

export const ALL_LANGUAGES = ["en", "de-DE", "fr-FR"];

export const DEFAULT_LANGUAGE = "en";

export function TolgeeBase() {
  const base = Tolgee()
    .use(FormatIcu())
    .use(DevTools())
    .use(LanguageDetector());

  return (
    env.TOLGEE_CDN_PREFIX_URL
      ? base.use(
          BackendFetch({
            prefix: env.TOLGEE_CDN_PREFIX_URL,
            fallbackOnFail: true,
          }),
        )
      : base
  ).updateDefaults({
    apiKey,
    apiUrl,
    defaultLanguage: DEFAULT_LANGUAGE,
    availableLanguages: ALL_LANGUAGES,
  });
}

export const MAPPED_LANGUAGES: Language[] = ALL_LANGUAGES.map((code) => {
  const languageCode = code.split("-")[0] ?? "en";

  const localName = new Intl.DisplayNames([languageCode], {
    type: "language",
  }).of(languageCode);

  const capitalizedLocalName = localName
    ? localName.charAt(0).toUpperCase() + localName.slice(1)
    : undefined;

  const name =
    new Intl.DisplayNames(["en"], {
      type: "language",
    }).of(languageCode) || "Unknown";

  return {
    code,
    name,
    ...(capitalizedLocalName ? { localName: capitalizedLocalName } : {}),
  };
});
